function slickInit(itemToInit) {
    itemToInit
        .slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-arrow slick-prev"><img src="/magasiner/images/shared/small/icons/prev.svg" alt="Précédent" class="inject-me"></button>',
            nextArrow: '<button class="slick-arrow slick-next"><img src="/magasiner/images/shared/small/icons/next.svg" alt="Suivant" class="inject-me"></button>',
        });
}

function syncZoomProductLink(target) {
    var $html = $('html');
    var responsiveImgSrc = 'zoom-desk-img-src';
    if ($html.hasClass('mobile-size')) {
        responsiveImgSrc = 'zoom-default-img-src';
    } else if ($html.hasClass('tablet-size')) {
        responsiveImgSrc = 'zoom-tab-img-src';
    }

    var $zoomProduct = $('#zoom_product');

    var imagesSrc = $(target).data(responsiveImgSrc);
    if (imagesSrc === undefined || imagesSrc === null) {
        $zoomProduct.addClass('hide');
    } else {
        var imageURL = '';
        var zoomImages = imagesSrc.split(', ');
        var pixelRatio = window.devicePixelRatio;
        if (pixelRatio === 1) {
            imageURL = zoomImages[0].trim().split(' ')[0];
        } else {
            imageURL = zoomImages[zoomImages.length - 1].trim().split(' ')[0];
        }

        var img = new Image();
        img.onload = function () {
            $zoomProduct.removeClass('hide');
            $zoomProduct.attr('href', imageURL);
        };
        img.onerror = function () {
            $zoomProduct.addClass('hide');
        };
        img.src = imageURL;
    }
}

function updateProductPicture(sourceId, value, media, insertAfterSelector) {
    var $source = $('#' + sourceId);
    if (value === null || value === undefined || value === '') {
        if ($source.length) {
            $source.remove();
        }
    } else if ($source.length) {
        $source.attr('srcset', value);
    } else {
        var source = document.createElement('source');
        source.id = sourceId;
        source.srcset = value;
        source.media = media;

        var $parent = $('#main-img');
        if (insertAfterSelector !== undefined) {
            var $element = $parent.find(insertAfterSelector);
            if ($element.length) {
                $element.after(source);
            } else {
                $parent.prepend(source);
            }
        } else {
            $parent.prepend(source);
        }
    }
}

function bindProductImageSlider() {
    $('.pi--thumbnail-item img').bind('click keydown', function (e) {
        if (e.type === 'click' || e.keyCode == 13) {
            $('.pi--thumbnail-item--current').removeClass('pi--thumbnail-item--current');

            var $this = $(this);

            var $mob = $('#mob-img');
            $mob.attr('src', $this.attr('src'));
            updateProductPicture('desk-img', $this.attr('data-desk-img-src'), '(min-width: 1200px)');
            updateProductPicture('tab-img', $this.attr('data-tab-img-src'), '(min-width: 730px)', 'desk-img');
            $this.closest('picture').addClass('pi--thumbnail-item--current');

            syncZoomProductLink($this);

            picturefill({reevaluate: true, elements: $mob});
        }
    }).first().trigger('click');
}

$(document).ready(function () {

    bindProductImageSlider();

    $('#zoom_product').fancybox({
        type: 'image',
        width: 600,
        minWidth: 600,
        maxWidth: 600,
        autoSize: false,
        closeBtn: true,
        afterShow: function () {
            pushDataLayerProductDetailZoomIn();
            var $closeLink = $('<a class="close" href="#"><span class="invisible-text">Close</span></a>');
            $(this.inner).append($closeLink);
            $closeLink.on('click keypress', function () {
                $.fancybox.close();
                $("#zoom_product").focus();
            });
        }
    });
});